import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CloudinaryImage } from '@cloudinary/url-gen';
import { dpr } from '@cloudinary/url-gen/actions/delivery';
import { fill, thumbnail  } from '@cloudinary/url-gen/actions/resize';
import { byRadius, max } from '@cloudinary/url-gen/actions/roundCorners';
import { CommonModule } from '@angular/common';
import { CloudinaryModule } from '@cloudinary/ng';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';

@Component({
    selector: 'image-cloud-wrapper',
    template: `@if (image) {<advanced-image [cldImg]="image"></advanced-image>}`,
    standalone: true,
    imports: [CommonModule, CloudinaryModule]
})
export class MyImageComponent implements OnChanges {
  @Input() publicId!: string | undefined | null;
  @Input() isDark: boolean | null = false;
  @Input() size: number = 50;
  @Input() width: number | null = null;
  @Input() height: number | null = null;
  @Input() radius: number = 20;
  image!: CloudinaryImage;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['publicId'] || changes['width'] || changes['height'] || changes['size']) {
      this.transformImage(this.publicId || 'defaultprofile');
    }
  }

  // Image transformations: https://cloudinary.com/documentation/angular_image_transformations
transformImage(id: string) {
    const imgWidth = this.width ?? this.size;
    const imgHeight = this.height ?? this.size;

    this.image = new CloudinaryImage(id, { cloudName: 'fitpromaster' });


  this.image
      .resize(fill().width(imgWidth).height(imgHeight).gravity(autoGravity()))
      .format('auto')
      .quality('auto')
      .delivery(dpr('auto')) // Crop the image, focusing on the face.
      .roundCorners(byRadius(this.radius));
}
}
